/**
 * Product Utility File
 *
 * @exports utils/product
 * @category Utils
 */

/**
 * Evaluate the product object and key that is passed to determine if the object passed is a stop loss product.
 *
 * @param {object} product
 * @param {string} key
 * @returns {boolean}
 */
export const isStopLoss = (product, key = 'product_type_name') => product[key].toLowerCase() === 'stop loss';

export default {
  isStopLoss,
};
